/* Author editing and private, read-only history. The server is the authority for access. */
document.addEventListener('alpine:init', () => {
  const targets = new Map();
  const bare = value => String(value || '').split('/').pop();
  const reference = post => ({blog:post.blog,handle:bare(post.handle)});
  const key = post => post.blog + '/' + bare(post.handle);
  Alpine.store('edits', {
    enabled:false, moderator:false, customer:'', values:{}, open:false, mode:'edit', post:null,
    loading:false, busy:false, error:'', title:'', body:'', summary:'', original:null, latest:null,
    history:[], next:null, conflict:false, discardPrompt:false, request:null, epoch:0, timer:null, polling:false,
    init() {
      this.customer = document.querySelector('[data-customer-id]')?.dataset.customerId || '';
      this.onLost = () => { this.enabled=false; this.moderator=false; this.customer=''; this.close(true); clearTimeout(this.timer); };
      window.addEventListener('modl-auth-lost',this.onLost);
      window.addEventListener('pagehide',()=>{this.close(true);clearTimeout(this.timer);});
      window.addEventListener('pageshow',event=>{if(event.persisted)void this.connect();});
      document.addEventListener('visibilitychange',()=>{clearTimeout(this.timer);if(!document.hidden)void this.refresh();});
      window.addEventListener('beforeunload',event=>{if(this.open&&this.mode==='edit'&&this.dirty()){event.preventDefault();event.returnValue='';}});
      void this.connect();
    },
    async connect() {
      try {const response=await window.ModlCommunityAPI.publicEditing('/session');if(!response.ok)return;
        const data=await response.json();this.enabled=data.enabled===true;this.moderator=data.moderator===true;
        if(this.enabled)void this.refresh();
      } catch { /* Old backends and offline previews do not expose editing controls. */ }
    },
    register(post) {
      const k=key(post),entry=targets.get(k);targets.set(k,{post:reference(post),count:(entry?.count||0)+1});
      if(this.enabled){clearTimeout(this.timer);this.timer=setTimeout(()=>this.refresh(),100);}
    },
    unregister(post) {const k=key(post),entry=targets.get(k);if(entry?.count>1)entry.count--;else targets.delete(k);},
    current(blog,handle) {return this.values[key({blog,handle})];},
    timestamp(value) {
      if (!value) return '';
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return '';
      const day = date.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit' });
      const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
      return `${day} · ${time}`;
    },
    stamp(blog,handle) {return this.current(blog,handle)?.edited_at || '';},
    own(post) {return !!this.customer && bare(post.owner)===this.customer;},
    canEdit(post) {return this.enabled&&(post.linked_page?!!this.customer&&this.moderator:this.own(post))&&!Alpine.store('moderation')?.hidden(post.blog,bare(post.handle));},
    canHistory(post) {return this.enabled&&!!this.customer&&(this.own(post)||this.moderator);},
    apply(item) {
      if(this.values[key(item)]?.version===item.version)return;
      this.values[key(item)]=item;
      window.dispatchEvent(new CustomEvent('modl-content-edited',{detail:item}));
    },
    async refresh() {
      clearTimeout(this.timer);if(!this.enabled||this.polling||document.hidden)return;
      this.polling=true;
      try {const posts=[...targets.values()].map(entry=>entry.post);
        for(let i=0;i<posts.length;i+=100){if(document.hidden||!this.enabled)break;
          const response=await window.ModlCommunityAPI.publicEditing('/updates?'+new URLSearchParams({refs:JSON.stringify(posts.slice(i,i+100))}));
          if(!response.ok)break;const data=await response.json();for(const item of data.items||[])this.apply(item);
        }
      } catch { /* Keep the displayed content when a background refresh fails. */ }
      finally {this.polling=false;if(this.enabled&&!document.hidden)this.timer=setTimeout(()=>this.refresh(),10000);}
    },
    async api(path='',options={}) {
      const response=await window.ModlCommunityAPI.request('/api/edits'+path,options);
      const data=await response.json().catch(()=>({}));
      if(!response.ok){const error=Error(data.error||'Could not load this post. Please try again.');Object.assign(error,{status:response.status,code:data.code});throw error;}
      return data;
    },
    query() {return '?'+new URLSearchParams(reference(this.post));},
    dirty() {return !!this.original&&(this.title!==this.original.title||this.body!==this.original.body||(this.original.linked_page&&this.summary!==(this.original.summary||'')));},
    async show(post,mode='edit') {
      if(this.open||!this.enabled)return;
      const epoch=++this.epoch;this.post=reference(post);this.mode=mode;this.error='';this.original=null;
      this.title='';this.body='';this.summary='';this.latest=null;this.history=[];this.next=null;this.conflict=false;this.request=null;
      this.discardPrompt=false;this.loading=true;this.open=true;
      document.getElementById('modl-edit-dialog')?.showModal();
      try {
        if(mode==='history'){await this.moreHistory(epoch);return;}
        const data=await this.api(this.query());if(epoch!==this.epoch)return;
        if(!data.can_edit)throw Error('This post cannot currently be edited.');
        this.original=data.post;this.title=data.post.title;this.body=data.post.body;this.summary=data.post.summary||'';
      }catch(e){if(epoch===this.epoch)this.error=e.message;}
      finally{if(epoch===this.epoch)this.loading=false;}
    },
    close(force=false) {
      if(this.busy&&!force)return;
      if(!force&&this.mode==='edit'&&this.dirty()){this.discardPrompt=true;return;}
      this.epoch++;this.open=false;this.original=null;this.latest=null;this.body='';this.title='';this.summary='';this.history=[];
      this.request=null;this.discardPrompt=false;this.loading=false;this.busy=false;
      document.getElementById('modl-edit-dialog')?.close();
    },
    async save() {
      if(this.busy||!this.original||this.conflict)return;
      if(!this.original.linked_page)document.querySelector('[data-content-edit-editor]')?.dispatchEvent(new CustomEvent('rte-sync'));
      const epoch=this.epoch;this.busy=true;this.error='';
      const payload={...reference(this.post),title:this.title,body:this.body,...(this.original.linked_page?{summary:this.summary}:{}),version:this.original.version};
      const fingerprint=JSON.stringify(payload);
      if(!this.request||this.request.fingerprint!==fingerprint)this.request={fingerprint,id:crypto.randomUUID()};
      try {
        const result=await this.api('',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({...payload,request_id:this.request.id})});
        if(epoch!==this.epoch)return;
        if(!result.unchanged)this.apply(result.post);
        this.busy=false;this.close(true);
      }catch(e){if(epoch===this.epoch){this.error=e.message;this.conflict=e.code==='EDIT_CONFLICT';if(e.status===400||e.status===422)this.request=null;}}
      finally{if(epoch===this.epoch)this.busy=false;}
    },
    async reviewLatest() {
      if(this.busy)return;const epoch=this.epoch;this.busy=true;
      try {const data=await this.api(this.query());if(epoch===this.epoch){if(!data.can_edit)throw Error('This post can no longer be edited.');this.latest=data.post;}}
      catch(e){if(epoch===this.epoch)this.error=e.message;}finally{if(epoch===this.epoch)this.busy=false;}
    },
    useLatest(keepDraft) {
      if(!this.latest)return;this.original=this.latest;
      if(!keepDraft){this.title=this.latest.title;this.body=this.latest.body;this.summary=this.latest.summary||'';}
      this.latest=null;this.conflict=false;this.request=null;this.error='';
    },
    async moreHistory(epoch=this.epoch) {
      if(this.busy)return;this.busy=true;this.error='';
      try {const data=await this.api('/history'+this.query()+(this.next?'&before='+encodeURIComponent(JSON.stringify(this.next)):''));
        if(epoch===this.epoch){this.history.push(...data.items);this.next=data.next;}}
      catch(e){if(epoch===this.epoch)this.error=e.message;}finally{if(epoch===this.epoch)this.busy=false;}
    },
  });
  Alpine.data('ForumEditActions',post=>({post:{...post,...reference(post)},init(){this.$store.edits.register(this.post);},destroy(){this.$store.edits.unregister(this.post);}}));
  Alpine.data('EditedTopic',(blog,handle)=>({
    title:'',body:'',
    init(){this.title=this.$refs.title.textContent;this.body=this.$refs.body.innerHTML;},
    currentTitle(){return this.$store.edits.current(blog,handle)?.title ?? this.title;},
    currentBody(){return this.$store.edits.current(blog,handle)?.body ?? this.body;}
  }));
});
